import { Flex, Stack, Text } from "@chakra-ui/react";
import { QRCodeSVG } from "qrcode.react";
import { useEffect, useState } from "react";
import COLOR from "../../../constant/COLOR";
import IMAGES from "../../../constant/IMAGES";
import useResponsive from "../../../hooks/useResponsive";
import redirect from "../../../utils/redirect";

const getMobileOS = (): string | false => {
  const userAgent = navigator.userAgent;

  if (/Android/i.test(userAgent)) {
    return "Android";
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return "iOS";
  }

  return false;
};

export const detectAndHandleRedirect = () => {
  const mobileOS = getMobileOS();
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");
  urlParams.delete("code");
  let redirectLink, fallbackUrl;
  if (mobileOS === "Android") {
    fallbackUrl =
      "https://play.google.com/store/apps/details?id=com.xhero_app&hl=vi-VN";
  } else if (mobileOS === "iOS") {
    fallbackUrl = "https://apps.apple.com/vn/app/xhero/id6504331040";
  } else {
    fallbackUrl = "https://apps.apple.com/vn/app/xhero/id6504331040";
  }
  if (code && code !== "") {
    redirectLink = `xhero://xhero.deeplink?referral=${code}&${urlParams.toString()}`;
  } else {
    redirectLink = `xhero://xhero.deeplink?${urlParams.toString()}`;
  }
  redirect(redirectLink, fallbackUrl);
};

const Section1 = () => {
  const { isMobile, isMobileOrTablet, isTabletOrLaptop } = useResponsive();
  const [dataQr, setDataQr] = useState<string | null>(null);
  const [isBouncing, setIsBouncing] = useState(false);

  useEffect(() => {
    setIsBouncing(true);
  }, []);

  const getLink = () => {
    const queryString = new URL(window.location.href).search;
    const urlParams = new URLSearchParams(queryString);

    const code = urlParams.get("code");
    const redirect = urlParams.get("redirect");

    urlParams.delete("code");
    urlParams.delete("redirect");
    let updatedQueryString = urlParams.toString();
    if (code) {
      updatedQueryString += `&referral=${code}`;
    }

    for (const [key, value] of urlParams.entries()) {
      console.log(`${key}: ${value}`);
    }
    if (redirect !== "1") return;
    window.location.href = "xhero://xhero.deeplink?" + updatedQueryString;

    setTimeout(() => {
      const mobileOS = getMobileOS();

      if (mobileOS === "Android") {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.xhero_app&hl=vi-VN";
      } else if (mobileOS === "iOS") {
        window.location.href =
          "https://apps.apple.com/vn/app/xhero/id6504331040";
      } else {
        window.location.href =
          "https://apps.apple.com/vn/app/xhero/id6504331040";
      }
    }, 1000);
  };

  useEffect(() => {
    getLink();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    urlParams.set("redirect", "1");
    const updatedQueryString = urlParams.toString();
    const link = `${window.location.origin}?${updatedQueryString}`;
    if (code) {
      setDataQr(link);
    }
  }, []);

  const ImageStyle = {
    width: "70px",
    height: "30px",
  };

  return (
    <>
      <style>{`
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }
        
        .bounce {
          animation: bounce 0.5s infinite; 
        }
      `}</style>

      <Flex
        justifyContent="space-between"
        width="100%"
        direction={isMobileOrTablet ? "column-reverse" : "row"}
        gap="40px"
        mb="50px"
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          spacing={isMobile ? 2 : 5}
          sx={{
            transform: dataQr
              ? isMobile
                ? "translateY(-110px)"
                : "translateY(-50px)"
              : isMobile
              ? "translateY(-80px)"
              : "translateY(-10px)",
          }}
        >
          <img
            src={IMAGES.textX}
            alt=""
            style={{
              width: "600px",
              height: "auto",
            }}
          />
          <Text
            sx={{
              color: COLOR.whitePrimary,
              fontStyle: "italic",
              fontSize: isMobile ? "13px" : "20px",
              fontWeight: 400,
            }}
          >
            Ứng dụng Phong thủy kết nối giá trị văn hóa Gia Đình Việt.
          </Text>
          <Flex gap="15px" display={!dataQr ? "flex" : "none"}>
            <img
              src={IMAGES.arrowL}
              alt=""
              style={ImageStyle}
              className={isBouncing ? "bounce" : ""}
            />
            <Stack
              onClick={detectAndHandleRedirect}
              transition="all 235ms ease-in-out"
              cursor="pointer"
              _hover={{
                transform: "translate3d(0, 2px, 0)",
              }}
            >
              <img
                src={IMAGES.bttDown}
                alt=""
                style={{
                  width: "200px",
                  height: "auto",
                  transform: "translateY(10px)",
                }}
              />
            </Stack>
            <img
              src={IMAGES.arrowR}
              alt=""
              style={ImageStyle}
              className={isBouncing ? "bounce" : ""}
            />
          </Flex>
        </Stack>
        <Stack
          alignItems={isMobileOrTablet ? "center" : "start"}
          justifyContent={isMobileOrTablet ? "center" : "flex-start"}
          sx={{ transform: isMobile ? "translateY(-20px)" : "0" }}
        >
          {dataQr ? (
            <Stack position="relative">
              <img
                src={IMAGES.bgQr}
                alt=""
                style={{ width: "600px", height: "auto" }}
              />
              <Stack
                sx={{
                  position: "absolute",
                  top: "35%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                }}
              >
                <Stack position="relative">
                  <Stack position="relative">
                    <Stack
                      sx={{
                        borderRadius: "20px",
                        overflow: "hidden",
                      }}
                    >
                      <QRCodeSVG
                        value={dataQr}
                        size={isMobile ? 100 : isTabletOrLaptop ? 150 : 210}
                      />
                    </Stack>
                    <Stack
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)",
                        borderRadius: "20px",
                        width: isMobile
                          ? "115px"
                          : isTabletOrLaptop
                          ? "175px"
                          : "235px",
                      }}
                    >
                      <img
                        src={IMAGES.borderQr}
                        alt=""
                        style={{ height: "auto" }}
                      />
                    </Stack>
                  </Stack>
                  <img
                    src={IMAGES.logo}
                    alt=""
                    style={{
                      width: isMobile
                        ? "20px"
                        : isTabletOrLaptop
                        ? "30px"
                        : "40px",
                      height: "auto",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%,-50%)",
                    }}
                  />
                </Stack>
              </Stack>
              <Stack
                sx={{
                  position: "absolute",
                  bottom: isMobile ? "30%" : "25%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                }}
                onClick={detectAndHandleRedirect}
              >
                <img
                  src={IMAGES.bttQr}
                  alt=""
                  style={{
                    width: isMobile
                      ? "110px"
                      : isTabletOrLaptop
                      ? "150px"
                      : "225px",
                    height: "auto",
                  }}
                  className={isBouncing ? "bounce" : ""}
                />
              </Stack>
            </Stack>
          ) : (
            <Stack position="relative">
              <img
                src={IMAGES.mockup}
                alt=""
                style={{ width: "600px", height: "auto", zIndex: 1 }}
              />
              <img
                src={IMAGES.blur}
                alt=""
                style={{
                  width: "100%",
                  height: "auto",
                  position: "absolute",
                  top: "70%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                }}
              />
            </Stack>
          )}
        </Stack>
      </Flex>
    </>
  );
};

export default Section1;
